import { Suspense } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const LoadingSpinner = () => {
  return (
    <Box
      className="col-span-full flex items-center justify-center p-8"
      sx={{ height: "calc(100vh - 137px)" }}
    >
      <CircularProgress size={42} thickness={4} className="text-red-100" />
    </Box>
  );
};

const LazyLoadWrapper = ({ component: Component }) => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  );
};

export default LazyLoadWrapper;
